module.exports = __webpack_public_path__ + "static/media/erro-404-min.a95ba2dc.png";